import React from 'react';
import { motion } from 'framer-motion';
export function Founders() {
  const team = [{
    name: 'Prabha Dublish',
    role: 'CEO',
    bio: 'First product hire at Grow Therapy (Sequoia-backed, scaled from $90M to $3B valuation). Launched AI features at Grow. Former Meta PM & PMM.',
    linkedin: 'https://www.linkedin.com/in/prabhadublish/',
    photo: 'https://cdn.magicpatterns.com/uploads/g9qZEJb4W9KnT3KxrakHgw/headshot.jpg'
  }, {
    name: 'Aaron Leon',
    role: 'CTO',
    bio: "Tech lead at Amazon One Medical, led 50+ engineers on the in-house EHR and AI tools serving 1M+ patients. Built Amazon Care's data platform from zero to nationwide scale.",
    linkedin: 'https://www.linkedin.com/in/aaronleon1/',
    photo: 'https://cdn.magicpatterns.com/uploads/9HNXXcqHNdKqVfvZuWedv4/aaron_profile.jpg'
  }];
  return <section id="team" className="py-24 bg-hubble-card/20 relative z-10 border-t border-hubble-border/50" data-id="element-34">
      <div className="max-w-7xl mx-auto px-6" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <span className="text-hubble-signal text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-37">
            TEAM
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-paper" data-id="element-38">
            Built by people who've done this before.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-39">
          {team.map((person, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center p-8 rounded-2xl border border-hubble-border bg-hubble-card" data-id="element-40">
              <div className="w-24 h-24 rounded-full bg-hubble-ink border border-hubble-border mb-6 flex items-center justify-center overflow-hidden" data-id="element-41">
                {person.photo ? <img src={person.photo} alt={person.name} className="w-full h-full object-cover" data-id="element-42" /> : <div className="w-full h-full flex items-center justify-center font-heading text-2xl text-hubble-paper/70" data-id="element-43">
                    {person.name.charAt(0)}
                  </div>}
              </div>

              <h3 className="font-heading text-2xl font-medium text-hubble-paper mb-2" data-id="element-44">
                <a href={person.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-hubble-signal transition-colors" data-id="element-45">
                  {person.name}
                </a>
              </h3>
              <div className="text-hubble-signal font-body text-sm mb-4" data-id="element-46">
                {person.role}
              </div>
              <p className="font-body text-[16px] text-hubble-paper/70 leading-[1.6]" data-id="element-47">
                {person.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}